

//qnbar平台工具的基础配置
//var PT = require('./vendor/qnbar/platform.js');
import Platform from './vendor/qnbar/platform.js'

var PT = new Platform.Platform();
PT.config.env = "test";
PT.config.hostBaseUrl = 'https://bz.qnbar.cn/';
PT.config.platformUsagespace = 'PT_MIX_BZ';
PT.config.apiBaseUrl = 'https://api2.qnbar.cn/';
PT.config.qnloginBaseUrl = "http://passport.t.qnbar.cn/";
PT.config.qnloginPlatformNo = 10;  
PT.config.loginJumpBackUrl = encodeURIComponent(PT.config.hostBaseUrl);
PT.config.wsHost = "ws.qnbar.cn";
PT.config.wsPort = "16668";
PT.config.wsProto = "wss";
PT.init();

export default {
    PT : PT
}


// WEBPACK FOOTER //
// ./src/env.test.js